import { CRUD } from "@/shared/components";
import {
  DeleteInternalExpensesMutation,
  InternalExpensesListQuery,
  RestoreInternalExpensesMutation,
  type InternalExpensesListRow,
} from "@/admin/entities/internalExpenses";
import { BillingExpensesConfig, BillingExpensesSchemas } from "../model";

export function BillingExpenses() {
  return (
    <CRUD<InternalExpensesListRow>
      listQuery={InternalExpensesListQuery}
      getTableData={BillingExpensesConfig.getTableData}
      mapColumns={BillingExpensesConfig.mapColumns}
      columns={BillingExpensesConfig.getColumnsConfig()}
      totalSchema={BillingExpensesConfig.getTotalSchema()}
      filterSchema={BillingExpensesSchemas.filterSchema}
      normalizeFilter={BillingExpensesSchemas.normalizeFilter}
      createSchema={BillingExpensesSchemas.createSchema}
      createInitialVariables={BillingExpensesSchemas.createInitialVariables}
      editSchema={BillingExpensesSchemas.editSchema}
      deleteMutation={DeleteInternalExpensesMutation}
      restoreMutation={RestoreInternalExpensesMutation}
      texts={BillingExpensesConfig.getTextsConfig()}
      persistFilters
      useMobileView
      mobileColumns={BillingExpensesConfig.getMobileColumnsConfig()}
    />
  );
}
